(function () {
  'use strict';

  var horizontalRailQuery = window.matchMedia('(min-width: 960px)');

  function onMediaChange(query, callback) {
    if (query.addEventListener) query.addEventListener('change', callback);
    else if (query.addListener) query.addListener(callback);
  }

  function normalizeTier(value) {
    return String(value || '')
      .trim()
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-|-$/g, '');
  }

  function initializeLevelMap(map) {
    if (!map || map.getAttribute('data-bc-level-map-ready') === 'true') return;

    var rail = map.querySelector('[data-bc-level-tabs]');
    var tabs = Array.prototype.slice.call(map.querySelectorAll('[data-bc-level-tab]'));
    var panels = Array.prototype.slice.call(map.querySelectorAll('[data-bc-level-panel]'));
    var announcement = map.querySelector('[data-bc-level-map-announcement]');

    if (!rail || !tabs.length || tabs.length !== panels.length) return;

    var panelByTier = {};
    var hasMatchingPanels = panels.every(function (panel) {
      var tier = panel.getAttribute('data-bc-tier');
      if (!tier || panelByTier[tier]) return false;
      panelByTier[tier] = panel;
      return true;
    }) && tabs.every(function (tab) {
      return Boolean(panelByTier[tab.getAttribute('data-bc-tier')]);
    });

    if (!hasMatchingPanels) return;

    panels = tabs.map(function (tab) {
      return panelByTier[tab.getAttribute('data-bc-tier')];
    });

    try {
      var numberFormatter = new Intl.NumberFormat(document.documentElement.lang || undefined);
      map.querySelectorAll('[data-bc-level-points]').forEach(function (value) {
        var points = Number(value.getAttribute('data-bc-level-points'));
        if (Number.isFinite(points)) value.textContent = numberFormatter.format(points);
      });
    } catch (error) {
      // Server-rendered numbers remain understandable if Intl is unavailable.
    }

    var activeIndex = tabs.findIndex(function (tab) {
      return tab.getAttribute('data-bc-active') === 'true';
    });
    if (activeIndex < 0) activeIndex = 0;

    // The authenticated status request can finish before this controller is
    // ready. In that race, the status script has already marked the verified
    // current tier but its selection event had no listener yet. Prefer that
    // verified state over the server-rendered fallback selection.
    var currentIndex = tabs.findIndex(function (tab) {
      return tab.getAttribute('data-bc-state') === 'current';
    });
    if (currentIndex >= 0) activeIndex = currentIndex;

    var userHasSelected = false;
    if (map.getAttribute('data-bc-tracking-context') === 'beefcake-club-page') {
      var requestedLevel = new URLSearchParams(window.location.search).get('bc_level');
      var requestedKey = normalizeTier(requestedLevel);
      if (requestedKey) {
        var requestedIndex = tabs.findIndex(function (tab) {
          return tab.getAttribute('data-bc-tier') === requestedKey ||
            tab.getAttribute('data-bc-level') === requestedLevel;
        });
        if (requestedIndex >= 0) {
          activeIndex = requestedIndex;
          userHasSelected = true;
        }
      }
    }

    function updateOrientation() {
      var isHorizontal = map.classList.contains('bc-level-map--teaser') || horizontalRailQuery.matches;
      rail.setAttribute('aria-orientation', isHorizontal ? 'horizontal' : 'vertical');
    }

    function announceSelection(index) {
      if (!announcement) return;
      var tab = tabs[index];
      var tierName = tab.querySelector('.bc-level-map__tab-name--full');
      var routes = tab.querySelector('.bc-level-map__tab-routes');
      var message = 'Viewing ' + (tierName ? tierName.textContent.trim() : 'selected level') + '.';
      if (routes) message += ' ' + (routes.getAttribute('aria-label') || routes.textContent.trim()) + '.';
      announcement.textContent = '';
      window.requestAnimationFrame(function () {
        announcement.textContent = message;
      });
    }

    function applySelection() {
      tabs.forEach(function (tab, index) {
        var isActive = index === activeIndex;
        tab.setAttribute('data-bc-active', isActive ? 'true' : 'false');
        tab.setAttribute('role', 'tab');
        tab.setAttribute('aria-controls', panels[index].id);
        tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
        tab.setAttribute('tabindex', isActive ? '0' : '-1');
      });

      panels.forEach(function (panel, index) {
        var isActive = index === activeIndex;
        panel.setAttribute('data-bc-active', isActive ? 'true' : 'false');
        panel.setAttribute('role', 'tabpanel');
        panel.setAttribute('aria-labelledby', tabs[index].id);
        panel.hidden = !isActive;
      });
    }

    function selectLevel(index, options) {
      options = options || {};
      var previousIndex = activeIndex;
      activeIndex = Math.max(0, Math.min(index, tabs.length - 1));
      var changed = activeIndex !== previousIndex;

      if (options.userInitiated) userHasSelected = true;
      applySelection();

      if (options.focusTab) tabs[activeIndex].focus();
      if (options.announce && changed) announceSelection(activeIndex);

      if (options.updateUrl && map.getAttribute('data-bc-tracking-context') === 'beefcake-club-page') {
        var levelUrl = new URL(window.location.href);
        levelUrl.searchParams.set('bc_level', tabs[activeIndex].getAttribute('data-bc-tier'));
        window.history.replaceState(window.history.state, '', levelUrl.toString());
      }

      if (options.emitChange !== false && changed) {
        map.dispatchEvent(new CustomEvent('bc-level-map:change', {
          bubbles: true,
          detail: {
            level: activeIndex + 1,
            tier: tabs[activeIndex].getAttribute('data-bc-tier') || '',
            previous_tier: tabs[previousIndex] ? tabs[previousIndex].getAttribute('data-bc-tier') || '' : '',
            source: options.source || 'unknown'
          }
        }));
      }
    }

    tabs.forEach(function (tab, index) {
      tab.addEventListener('click', function () {
        selectLevel(index, {
          userInitiated: true,
          announce: true,
          updateUrl: true,
          source: 'tier_control'
        });
      });

      tab.addEventListener('keydown', function (event) {
        var nextIndex = null;
        var isHorizontal = rail.getAttribute('aria-orientation') === 'horizontal';
        if ((isHorizontal && event.key === 'ArrowRight') || (!isHorizontal && event.key === 'ArrowDown')) {
          nextIndex = (index + 1) % tabs.length;
        } else if ((isHorizontal && event.key === 'ArrowLeft') || (!isHorizontal && event.key === 'ArrowUp')) {
          nextIndex = (index - 1 + tabs.length) % tabs.length;
        } else if (event.key === 'Home') nextIndex = 0;
        else if (event.key === 'End') nextIndex = tabs.length - 1;

        if (nextIndex === null) return;
        event.preventDefault();
        selectLevel(nextIndex, {
          userInitiated: true,
          focusTab: true,
          announce: true,
          updateUrl: true,
          source: 'keyboard'
        });
      });
    });

    map.addEventListener('bc-level-map:select-request', function (event) {
      var detail = event.detail || {};
      if (userHasSelected && detail.force !== true) return;
      var requestedTier = normalizeTier(detail.tier);
      var requestedIndex = tabs.findIndex(function (tab) {
        return tab.getAttribute('data-bc-tier') === requestedTier;
      });
      if (requestedIndex < 0) return;
      selectLevel(requestedIndex, {
        updateUrl: false,
        emitChange: false,
        announce: detail.announce === true
      });
    });

    rail.setAttribute('role', 'tablist');
    updateOrientation();
    onMediaChange(horizontalRailQuery, updateOrientation);
    map.setAttribute('data-bc-level-map-ready', 'true');
    selectLevel(activeIndex, { emitChange: false });
  }

  function initializeAllLevelMaps(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('[data-bc-level-map]').forEach(initializeLevelMap);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initializeAllLevelMaps(document);
    });
  } else {
    initializeAllLevelMaps(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initializeAllLevelMaps(event.target);
  });
})();
